"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import csvParser from "csv-parser";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
interface PrimaryAddressData {
  profile_id: string;
  handle: string;
  current_primary: string;
  new_primary: string;
}
export default function AboutPrimaryAddress() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      border: "1px solid white",
      padding: "15px",
      verticalAlign: "middle"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const tdStyle = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["primaryAddressData"],
      queryFn: fetchPrimaryAddressData
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: t2,
    isLoading,
    error
  } = useQuery(t1);
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const primaryAddressData = t3;
  if (isLoading) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div>Loading...</div>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (error) {
    let t4;
    if ($[5] !== error.message) {
      t4 = <div>Error: {error.message}</div>;
      $[5] = error.message;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row><Col><h1>On-Chain Primary Address</h1></Col></Row>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Row className="pt-4"><Col className="font-larger font-bolder">Overview</Col></Row>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Row className="pt-4"><Col><span className="font-bolder">Single Address</span><ul><li className="pt-2">Primary address is the wallet address (no other addresses involved)</li></ul></Col></Row>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Row className="pt-2"><Col><span className="font-bolder">Consolidations</span><ul><li className="pt-2">By default, the primary address in a consolidation is the one with the highest individual TDH</li><li className="pt-2">If any of the addresses in the consolidation has registered a delegation for "Primary Address" use case (997) to an address in the same consolidation, then this delegated address becomes the Primary address of the consolidation</li></ul></Col></Row>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Col xs={12}>The following table shows the profiles which have selected a Primary Address other than the default Primary Address in their consolidation, and will be updated back to the default Primary Address on{" "}<u>Monday 29th April 2024</u>.</Col>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      overflowX: "auto"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <thead><tr><th style={tdStyle}>Profile Handle</th><th style={tdStyle}>Current Selected Primary Address</th><th style={tdStyle}>Primary Address Changed to</th></tr></thead>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== primaryAddressData) {
    let t12;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = item => <tr key={item.handle}><td style={tdStyle}><Link href={`/${item.current_primary}`} className="decoration-hover-underline">{item.handle}</Link></td><td style={tdStyle} className="font-smaller">{item.current_primary}</td><td style={tdStyle} className="font-smaller">{item.new_primary}</td></tr>;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    t11 = primaryAddressData.map(t12);
    $[14] = primaryAddressData;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <Container>{t4}{t5}{t6}{t7}<Row className="pt-4">{t8}<Col xs={12} className="pt-3" style={t9}><table className="table">{t10}<tbody>{t11}</tbody></table></Col></Row></Container>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}
async function fetchPrimaryAddressData(): Promise<PrimaryAddressData[]> {
  const response = await fetch("/primary_address.csv");
  if (!response.ok) {
    throw new Error(`Failed to fetch primary address data (${response.status})`);
  }
  const csvContent = await response.text();
  return parsePrimaryAddressCsv(csvContent);
}
function parsePrimaryAddressCsv(csvContent: string): Promise<PrimaryAddressData[]> {
  return new Promise((resolve, reject) => {
    const results: PrimaryAddressData[] = [];
    const parser = csvParser({
      headers: false
    }).on("data", (row: Record<string, string>) => {
      results.push({
        profile_id: row["0"]!,
        handle: row["1"]!,
        current_primary: row["2"]!,
        new_primary: row["3"]!
      });
    }).on("end", () => {
      results.sort((a, b) => a.handle.localeCompare(b.handle));
      resolve(results);
    }).on("error", (err: Error) => {
      console.error(err);
      reject(new Error("Failed to parse primary address data"));
    });
    try {
      parser.write(csvContent);
      parser.end();
    } catch (err) {
      console.error(err);
      reject(new Error("Failed to parse primary address data"));
    }
  });
}